module.exports = __webpack_public_path__ + "media/images/users_voice007-4ee985599c69d73bdf1329c71d5828cd.jpg";